/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "./poReports.styles.scss";

import dayjs from "dayjs";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import {
  Breadcrumb,
  Card,
  Col,
  Divider,
  Flex,
  Progress,
  Row,
  Space,
  Spin,
  Tag,
  Typography,
} from "antd";

import {
  selectSelectedCrop,
  selectCrops,
  selectBranches,
  selectVarieties,
  selectCurrentPage,
  selectViewAuctionPage,
  selectSelectedBranch,
  selectHubs,
  selectPoParams,
} from "../../redux/common/common.selectors";

import { Dispatch } from "redux";
import { selectUserData } from "../../redux/user/user.selectors";
import { dataConstants } from "../../constants/data-constants";

import {
  setPoScreen,
  setSelectedBranch,
  setSelectedCrop,
} from "../../redux/common/common.actions";
import {
  CheckCircleFilled,
  ExclamationCircleOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import { getPoReports } from "../../services/auction-services";
import { useLocation } from "react-router";

const { Text, Title } = Typography;

const PoDetails: React.FC = (props: any) => {
  const {
    branches,
    varietiesList,
    selectedCropId,
    userData,
    crops,
    currentpage,
    viewAuctionPage,
    selectedBranch,
    setSelectedBranchIndex,
    setSelectedCropIndex,
    hubs,
    selectParams,
    setPoScreens,
  } = props;
  const [selectedVariety, setSelectedVariety] = useState();
  const [selectedDates, setSelectedDates] = useState([
    dayjs().format("YYYY-MM-DD"),
    dayjs().format("YYYY-MM-DD"),
  ]);
  const [poDetails, setPoData] = useState([]);
  const [isSpinnerOnProgress, setIsSpinnerOnProgress] = useState(false);
  const location = useLocation();
  useEffect(() => {
    // if (currentpage == "6" && viewAuctionPage === "63" && selectParams) {
    if (location.pathname.includes("/reports/po") && selectParams) {
      getPoReportData();
    }
    // onBranchChange(selectedBranch, []);
  }, [
    currentpage,
    viewAuctionPage,
    selectedVariety,
    selectedDates,
    selectedBranch,
    selectedCropId,
    selectParams,
  ]);
  useEffect(() => {
    setSelectedVariety(undefined);
  }, [varietiesList]);
  const getPoReportData = async () => {
    const params = JSON.stringify({
      ...selectParams,
    });
    try {
      setIsSpinnerOnProgress(true);
      const response = await getPoReports(params);
      setPoData([]);
      if (response.data.status && response.data.data.length) {
        const data = response.data.data;
        // .map((item: any, index: number) => {
        //   return {
        //     key: index,
        //     auctionNumber: item.auction_id,
        //     time: item.auction_time,
        //     bidId: item.bid_id,
        //     vendorCode: item.vendor_code,
        //     vendorName: item.name_firm,
        //     date: item.auction_date,
        //     hub: item.hub_name,
        //     division: item.division,
        //     claim: item.claim,
        //     variety: item.variety_name,
        //     crop_id: selectedCropId,
        //     bidQty: item.bid_quantity,
        //     qtyFulfilled: item.alloted_qty === null ? 0 : item.alloted_qty,
        //     branchId: selectedBranch,
        //     branchName: item.branch_name,
        //     bidPrice: item.bid_price,
        //     saudaType: item.sauda_type,
        //     bidStatus: item.bid_status,
        //     poNnumber: item.PO_number,
        //     auction_type: item.auction_type,
        //   };
        // })
        // .filter((item) => item.auctionNumber !== undefined);
        setPoData(data);
      } else {
        // setVendorReportData([]);
      }
    } catch (error) {
      console.log(error);
      setPoData([]);
      // setIsLoading(false);
      // message.warning("Cannot fetch data...");
    } finally {
      setIsSpinnerOnProgress(false);
    }
  };
  return (
    <Spin spinning={isSpinnerOnProgress} tip="Please wait...">
      <Breadcrumb
        style={{
          paddingLeft: 30,
        }}
        items={[
          {
            title: (
              <>
                <LeftOutlined />
                <span>PO Reports</span>
              </>
            ),
            onClick: () => setPoScreens(false),
          },
          {
            title: selectParams.po_number,
          },
        ]}
      />
      <Card
        style={{
          margin: "25px 30px",
          border: "1px solid #B7FFB1",
          boxShadow: "0 0 3px #B7FFB1",
        }}
      >
        <>
          {poDetails.length > 0 &&
            poDetails.map((item: any) => (
              <Space
                key={item.Saudha_Id}
                direction="vertical"
                style={{ width: "stretch" }}
              >
                <Row>
                  <Col span={18} style={{ textAlign: "left" }}>
                    <Space
                      direction="vertical"
                      size={0}
                      style={{
                        paddingLeft: 30,
                      }}
                    >
                      <Text strong style={{ color: "#b6b6b6" }}>
                        PO Number
                      </Text>
                      <Title
                        level={4}
                        style={{ display: "inline", color: "#000000" }}
                      >
                        {item.PO_Number}
                      </Title>
                    </Space>
                    {item.Vendor_code && (
                      <>
                        <Space
                          direction="vertical"
                          size={0}
                          style={{
                            paddingLeft: 30,
                          }}
                        >
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Vendor Name
                          </Text>
                          <Title
                            level={4}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.Vendor_Name}
                          </Title>
                        </Space>
                        <Space
                          direction="vertical"
                          size={0}
                          style={{
                            paddingLeft: 30,
                          }}
                        >
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Vendor Code
                          </Text>
                          <Title
                            level={4}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.Vendor_code}
                          </Title>
                        </Space>
                      </>
                    )}
                    {item.Broker_code && (
                      <>
                        <Space
                          direction="vertical"
                          size={0}
                          style={{
                            paddingLeft: 30,
                          }}
                        >
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Broker Name
                          </Text>
                          <Title
                            level={4}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.Broker_Name}
                          </Title>
                        </Space>
                        <Space
                          direction="vertical"
                          size={0}
                          style={{
                            paddingLeft: 30,
                          }}
                        >
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Broker Code
                          </Text>
                          <Title
                            level={4}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.Broker_code}
                          </Title>
                        </Space>
                      </>
                    )}
                    <Space
                      direction="vertical"
                      size={5}
                      style={{
                        paddingLeft: 30,
                      }}
                    >
                      <Tag
                        color={
                          item.Payment_Status == "Paid" ? "success" : "warning"
                        }
                      >
                        {item.Payment_Status}
                      </Tag>
                    </Space>
                  </Col>
                  <Col span={6} style={{ textAlign: "right" }}>
                    <Space direction="horizontal" size={10}>
                      {/* <Calendar /> */}
                      <Space
                        direction="vertical"
                        size={0}
                        style={{ textAlign: "left" }}
                      >
                        <Text style={{ display: "inline", color: "#000000" }}>
                          PO Date
                        </Text>
                        <Text style={{ display: "inline" }}>
                          {dayjs(item.Purchase_Order_Date).format(
                            "DD MMM YYYY"
                          )}
                        </Text>
                      </Space>
                    </Space>
                  </Col>
                  <Col span={24} style={{ textAlign: "center" }}>
                    <Progress
                      percent={5}
                      strokeColor={"#fff"}
                      trailColor={"#fff"}
                      showInfo={false}
                    />
                  </Col>
                </Row>
                <Flex
                  style={{
                    maxHeight: "70vh",
                    overflow: "auto",
                    overflowX: "hidden",
                    padding: 0,
                    paddingLeft: 30,
                  }}
                  align="flex-start"
                  // gap={5}
                  // justify="space-evenly"
                  wrap
                >
                  <Space direction="vertical" style={{ width: "50vh" }}>
                    <Title level={5} underline>
                      Product Details
                    </Title>
                    <Row gutter={10}>
                      <Col span={12} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Crop Name
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.Crop_Name}
                          </Title>
                        </Space>
                      </Col>
                      <Col span={12} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Claim Type
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.ClaimType}
                          </Title>
                        </Space>
                      </Col>
                      <Col span={12} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Variety
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.Variety_Name || "--"}
                          </Title>
                        </Space>
                      </Col>
                      <Col span={12} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Crop Year
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.Crop_Year || "--"}
                          </Title>
                        </Space>
                      </Col>
                      <Col span={12} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Hub Name
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.Hub_Name || "--"}
                          </Title>
                        </Space>
                      </Col>
                      <Col span={12} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            PO Quantity (
                            {/* {
                              cropUnitList?.find((i) => i.id == item.Crop_Id)
                                ?.name
                            } */}
                            )
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.PO_Quantity}
                          </Title>
                        </Space>
                      </Col>
                      <Col span={12} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Branch Name
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.Branch_Name}
                          </Title>
                        </Space>
                      </Col>
                      <Col span={12} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Quality Deduction
                            {item.Quality_Unit
                              ? ` (${item.Quality_Unit})`
                              : " (₹)"}
                            `
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.Quality_Parameter ?? "--"}
                          </Title>
                        </Space>
                      </Col>
                      <Col span={12} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            PO Status
                          </Text>
                          <Title
                            level={5}
                            style={{
                              display: "inline",
                              color:
                                item.PO_Status == "CLOSED"
                                  ? "#47AB33"
                                  : "#E49D03",
                            }}
                          >
                            {item.PO_Status ?? "--"}{" "}
                            {item.PO_Status == "CLOSED" ? (
                              <CheckCircleFilled style={{ color: "#47AB33" }} />
                            ) : (
                              <ExclamationCircleOutlined
                                style={{ color: "#E49D03" }}
                              />
                            )}
                          </Title>
                        </Space>
                      </Col>
                    </Row>
                  </Space>
                  <Divider
                    type="vertical"
                    style={{
                      height: "-webkit-fill-available",
                      borderInlineStart: "2px solid #B7FFB1",
                      paddingInline: 5,
                    }}
                  />
                  <Space
                    direction="vertical"
                    style={{ width: "50vh", paddingInline: 10 }}
                  >
                    <Title level={5} underline>
                      Delivery Details
                    </Title>
                    <Row gutter={10}>
                      <Col span={12} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Invoice Number
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.Invoice_Number || "--"}
                          </Title>
                        </Space>
                      </Col>
                      <Col span={12} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Vehicle Number
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.Vehicle_Number || "--"}
                          </Title>
                        </Space>
                      </Col>
                      {/* <Col span={12} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            PO Number
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.PO_Number ?? "--"}
                          </Title>
                        </Space>
                      </Col> */}
                      <Col span={12} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Delivery Address
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.Delivery_Address ?? "--"}
                          </Title>
                        </Space>
                      </Col>
                      <Col span={12} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            GRN Date
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.GRN_Date
                              ? dayjs(item.GRN_Date).format("DD MMM YYYY")
                              : "--"}
                          </Title>
                        </Space>
                      </Col>
                      <Col span={12} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            GRN Number
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.GRN_ID || "--"}
                          </Title>
                        </Space>
                      </Col>
                      <Col span={12} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            GRN Quantity (
                            {
                              // cropUnitList?.find((i) => i.id == item.Crop_Id)
                              //   ?.name
                            }
                            )
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.GRN_Quantity}
                          </Title>
                        </Space>
                      </Col>
                      <Col span={12} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Delivery Status
                          </Text>
                          <Title
                            level={5}
                            style={{
                              display: "inline",
                              color:
                                item.Delivery_Status == "Delivered"
                                  ? "#47AB33"
                                  : "#E49D03",
                            }}
                          >
                            {item.Delivery_Status || ""}{" "}
                            {item.Delivery_Status == "Delivered" ? (
                              <CheckCircleFilled style={{ color: "#47AB33" }} />
                            ) : (
                              <ExclamationCircleOutlined
                                style={{ color: "#E49D03" }}
                              />
                            )}
                          </Title>
                        </Space>
                      </Col>
                    </Row>
                  </Space>
                  <Divider
                    type="vertical"
                    style={{
                      height: "-webkit-fill-available",
                      borderInlineStart: "2px solid #B7FFB1",
                      paddingInline: 5,
                    }}
                  />
                  <Space
                    direction="vertical"
                    style={{ width: "40vh", paddingInline: 10 }}
                  >
                    <Title level={5} underline>
                      Payment Details
                    </Title>
                    <Row>
                      <Col span={24} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Total Amount (₹)
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.Total_Amount ?? "--"}
                          </Title>
                        </Space>
                      </Col>
                      <Col span={24} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Executed PO Amount (₹)
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.Executed_PO_Amount}
                          </Title>
                        </Space>
                      </Col>
                      <Col span={24} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Balance Amount to be Paid (₹)
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.Balance_Amount}
                          </Title>
                        </Space>
                      </Col>
                      <Col span={24} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Payment Date
                          </Text>
                          <Title
                            level={5}
                            style={{ display: "inline", color: "#000000" }}
                          >
                            {item.Payment_Date
                              ? dayjs(item.Payment_Date).format("DD MMM YYYY")
                              : "--"}
                          </Title>
                        </Space>
                      </Col>
                      <Col span={24} style={{ textAlign: "left" }}>
                        <Space direction="vertical" size={0}>
                          <Text strong style={{ color: "#b6b6b6" }}>
                            Payment Status
                          </Text>
                          <Title
                            level={5}
                            style={{
                              display: "inline",
                              color:
                                item.Payment_Status == "Paid"
                                  ? "#47AB33"
                                  : "#E49D03",
                            }}
                          >
                            {item.Payment_Status}{" "}
                            {item.Payment_Status == "Paid" ? (
                              <CheckCircleFilled style={{ color: "#47AB33" }} />
                            ) : (
                              <ExclamationCircleOutlined
                                style={{ color: "#E49D03" }}
                              />
                            )}
                          </Title>
                        </Space>
                      </Col>
                    </Row>
                  </Space>
                </Flex>
                {/* <Flex style={{ paddingLeft: "4em" }}>
                  <Button
                    type="default"
                    size="large"
                    onClick={async () => {
                      const file = await dispatch(
                        fetchOrderReports({
                          saudha_id: item.Saudha_Id,
                          download: true,
                        }),
                      );
                      fileDownload(file, `Report_${item.Saudha_Id}.xlsx`);
                    }}
                    style={{
                      fontSize: 14,
                      fontWeight: 800,
                    }}
                  >
                    <DownloadOutlined style={{ fontSize: 20 }} />
                    Download PO
                  </Button>
                </Flex> */}
              </Space>
            ))}
        </>
      </Card>
    </Spin>
  );
};
const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setSelectedBranchIndex: (index: number) =>
      dispatch(setSelectedBranch(index)),
    setSelectedCropIndex: (index: number) => dispatch(setSelectedCrop(index)),
    setPoScreens: (status: boolean) => dispatch(setPoScreen(status)),
  };
};
const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  branches: selectBranches,
  crops: selectCrops,
  varietiesList: selectVarieties,
  selectedCropId: selectSelectedCrop,
  currentpage: selectCurrentPage,
  viewAuctionPage: selectViewAuctionPage,
  selectedBranch: selectSelectedBranch,
  selectParams: selectPoParams,
  hubs: selectHubs,
});

export default connect(mapStateToProps, mapDispatchToProps)(PoDetails);
